// Header.js
import React, { useEffect, useState, useRef } from "react";
import HeaderRightMenu from "./SubComponent/HeaderRightMenu/HeaderRightMenu";
import HeaderLeftMenu from "./SubComponent/HeaderLeftMenu";
import { useDispatch, useSelector } from "react-redux";
import { getGlobalConfig } from "../../redux/actions";
function Header(props) {
  const { setLoginHeader } = props 
  const device = useSelector(state => state.CommonConfig.device_type);
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.paginationData.currentStep)

  useEffect(() => {
    dispatch(getGlobalConfig());
  }, []);


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // Adjust breakpoint for mobile
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <div>
      <div className={`header ${device === "Desktop" ? "desktop" : "mobile"}`}
        // style={{
        //   zIndex:
        //     currentStep === 9
        //       ? (device === "Desktop" ? 0 : 9) // Set zIndex to 0 for Desktop if currentStep is 9
        //       : currentStep === 7
        //         ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 7
        //         : currentStep === 6
        //           ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 6
        //           : currentStep === 8
        //             ? (device === "Desktop" ? 0 : "revert-layer") // Set zIndex to 0 for Desktop if currentStep is 8
        //             : currentStep === 11
        //               ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 11
        //               : device === "Mobile" && [0, 1, 2, 10, 11].includes(currentStep)
        //                 ? -1
        //                 : 4, // Default zIndex
        // }}



        style={{
          zIndex:
            currentStep === 9
              ? (device === "Desktop" ? 0 : 9) // Set zIndex to 0 for Desktop if currentStep is 9
              : currentStep === 7
                ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 7
                : currentStep === 6
                  ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 6
                  : currentStep === 8
                    ? (device === "Desktop" ? 0 : "revert-layer") // Set zIndex to 0 for Desktop if currentStep is 8
                    : currentStep === 11
                      ? (device === "Desktop" ? 0 : 4) // Set zIndex to 0 for Desktop if currentStep is 11
                      : device === "Mobile" && currentStep === 3
                        ? 0 // Set zIndex to 1 for Mobile if currentStep is 3
                        : device === "Mobile" && [0, 1, 2, 10, 11].includes(currentStep)
                          ? -1
                          : 4, // Default zIndex
        }}

      >

        <HeaderLeftMenu setLoginHeader={setLoginHeader} />
        <HeaderRightMenu />


      </div>
      {currentStep === 11 && <div className="custom-overlay-mo-footer-header" style={{ height: "0%" }}></div>}
      {/* {currentStep === 12 && <div className="custom-overlay-mo-footer"  ></div>} */}

      {(isMobile && currentStep === 3) && (
        <div className="custom-overlay-mo-footer" style={{
          height:
            window.innerWidth <= 540
              ? "0%"
              : window.innerWidth <= 1024
              ? "0%"
              : "auto",
        }}></div>
      )}

      {isMobile && currentStep === 8 && (
        <div className="custom-overlay-mo-footer" style={{ height: "0%" }}></div>
      )}
      {!isMobile && currentStep === 8 && (
        <div className="custom-overlay-mo-footer-header" style={{ height: "0%" }}></div>
      )}

      {(isMobile && currentStep === 9) && (
        <div className="custom-overlay-mo-footer" style={{ height: "0%" }} ></div>
      )}

      {!isMobile && currentStep === 9 && (
        <div className="custom-overlay-mo-footer-header" style={{ height: "0%" }}></div>
      )}

      {!isMobile && currentStep === 10 && (
        <div className="custom-overlay-mo-footer-header" style={{ height: "15%" }}></div>
      )}

      {isMobile && currentStep === 10 && (
        <div className="custom-overlay-mo-footer" style={{ height: "0%" }}></div>
      )}

    </div>
  );
}

export default Header;
